export const converRequestStateToState = (status: any) => {
  if (status === 'Ok') {
    return 'success'
  }
  return status
}
